import Vue from 'vue';
import 'normalize.css/normalize.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/index.less';
import VueCropper from 'vue-cropper';
import BaiduMap from 'vue-baidu-map';
import MarqueeText from 'vue-marquee-text-component';
import VueLocalStorage from 'vue-localstorage';
import store from './store'
import QZ_CONFIG from '@/utils/config';
import '@/utils/permission';
import {message} from '@/utils/message'
import App from './app.vue';
import router from './router';


// 富文本
import '../public/UE/ueditor.config'
import '../public/UE/ueditor.all'
import '../public/UE/lang/zh-cn/zh-cn'
import '../public/UE/themes/default/css/ueditor.css'


Vue.component('marquee-text', MarqueeText);

Vue.use(VueCropper);
Vue.use(ElementUI);
Vue.use(VueLocalStorage);
Vue.prototype.$locSet = (key, val) => Vue.localStorage.set(key, JSON.stringify(val));
Vue.prototype.$locGet = (key) => JSON.parse(Vue.localStorage.get(key));
Vue.prototype.$locRemove = (key) => Vue.localStorage.remove(key);
Vue.prototype.$message = message;
Vue.use(BaiduMap, {
  ak: QZ_CONFIG.BAIDU_MAP_AK,
});
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
